module.exports = __webpack_public_path__ + "fonts/check_ul-2.svg";